<template>
  <div class="credentials">
<!-- Main Header -->
    <div class="bg-black p-2 rounded">
      <div class="">
        <div class="row">
            <div class="col-md-6">
              <div class="input-group flex-nowrap">
                <button class="btn btn-kraken rounded fs-5 me-1" @click="getCredentials('Refreshing credentials...')" title="Click to refresh the current credentials.">
                  <i class="fa-solid fa-key" :class="{'fa-fade': gettingCredentials || addingCredential || alteringCredential || deletingCredential}"></i>
                </button>
                <input class="btn bg-black text-white fw-light fs-5 rounded" style="width: 200px; cursor: default; letter-spacing: 3px; pointer-events:none;" type="text" value="Credentials" readonly>
                <select class="btn btn-kraken fs-5 fw-light rounded" style="width: 300px;" v-model="selected_ctype" @change="getCredentials('Getting credentials...')">
                  <option value="invalid">Select a credential type...</option>
                  <option value="enables">Enable Passwords</option>
                  <option value="network_elements">Network-Elements</option>
                  <option value="servers">Servers</option>
                  <option value="tacacs_sk">Tacacs Secret Key</option>
                  <option value="cloud_credentials">Cloud Credentials</option>
                  <option value="snmp_credentials">SNMP Credentials</option>
                  <option v-if="false" value="apis">API Credentials</option>
                  <option v-if="false" value="api_keys">API Keys (For Meraki, etc.)</option>
                  <option v-if="false" value="aruba_creds">Aruba Credentials (Cloud)</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
                <input class="btn bg-black text-white text-end fw-light fs-5 rounded w-100" style="width: 200px; cursor: default; pointer-events: none;" type="text" :value="timestamp" readonly>
            </div>
        </div>
      </div>
    </div>
    
<!-- START Container -->
    <div class="p-2 rounded mt-2" style="height: 575px;">

<!-- Waiting View. -->
      <div v-show="!credentialsReady" class="fs-3 text-white">
        <div style="margin-top: 17%;">
            <i class="fa-solid fa-xl fa-key" :class="{'fa-beat': gettingCredentials}"></i>
            <p class="text-white fw-light">{{credentialsMessage}}</p>
        </div>
      </div>
    
<!-- E N A B L E S -->
      <div class="" v-if="selected_ctype == 'enables' && credentialsReady">
<!-- Enables Header -->
        <div class="input-group flex-nowrap">
          <input type="text" class="btn text-white fs-5 w-50 text-start border-bottom-kraken me-1" :class="{'w-50': mode=='main', 'w-100': mode != 'main'}" style="opacity: 1;" value="Enable Passwords" disabled>
          <select v-show="mode=='main'" class="btn btn-kraken bg-gradient text-white fs-5 text-start border-kraken-bottom rounded" style="width:35%;" v-model="search_by">
            <option value="name">Filter by name</option>
            <option value="alias">Filter by alias</option>
          </select>
          <input v-show="mode=='main'" type="text" class="btn text-white fs-5 w-50 text-start border-bottom-kraken" style="opacity: 1; cursor: text;" v-model="search_word" placeholder="...">
          <button v-if="mode=='main'" class="btn btn-kraken fs-5 rounded" @click="selected_ctype='enables'; mode='add';">
            <i class="fa-solid fa-plus"></i>
          </button>
          <button v-if="mode=='add'" class="btn btn-suite-danger bg-gradient fs-5 rounded" @click="selected_ctype='enables'; mode='main'; clear();">
            <i class="fa-solid fa-close" :class="{'fa-beat-fade': mode=='add'}"></i>
          </button>
          <button v-if="mode=='edition'" class="btn btn-suite-danger bg-gradient fs-5 rounded" @click="selected_ctype='enables'; mode='main'; clear();">
            <i class="fa-solid fa-close" :class="{'fa-beat-fade': mode=='edition'}"></i>
          </button>
        </div>
<!-- Enables Table -->
        <div v-if="mode=='main'" class="mt-2">
          <div class="row">
            <div class="col-md-12">
              <!-- Enables Table Header -->
              <div class="input-group flex-nowrap" style="overflow-y: scroll; pointer-events: none;">
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 5%;" value="#" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 30%;" value="Name" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 30%;" value="Alias" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 25%;" value="Username" readonly>
                <button class="btn btn-kraken rounded fs-6 me-1" style="width: 5%;" readonly>
                  <i class="fa-solid fa-lg fa-pen"></i>
                </button>
                <button class="btn btn-kraken rounded fs-6" style="width: 5%;" readonly>
                  <i class="fa-solid fa-lg fa-trash"></i>
                </button>
              </div>
              <!-- Enables Table Content -->
              <div class="mt-1" style="height: 445px; overflow-y: scroll;">
                <div class="input-group flex-nowrap mb-1" v-for="(c, i) in filteredCreds" v-bind:key="i+1">
                  <input type="text" class="btn border-bottom-kraken text-white fs-6 me-1" style="width: 5%; cursor: text; pointer-events: none;" :value="i+1" readonly>
                  <input type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 30%; cursor: text; pointer-events: none;" :value="c.name" readonly>
                  <input type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 30%; cursor: text; pointer-events: none;" :value="c.alias" readonly>
                  <input v-if="c.username != null" type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 20%; cursor: text; pointer-events: none;" :value="c.username" readonly>
                  <input v-if="c.username == null" type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 25%; cursor: text; pointer-events: none;" value="-" readonly>
                  <button class="btn btn-kraken bg-gradient rounded fs-6 me-1" @click="setEdition(c, i+1)" style="width: 5%;">
                    <i class="fa-solid fa-lg fa-pen"></i>
                  </button>
                  <button class="btn btn-danger bg-gradient rounded fs-6" style="width: 5%; color: black; text-shadow: 3px 5px 4px rgb(180,0,0);" @click="deleteCredential(c, i+1)">
                    <i class="fa-solid fa-lg fa-trash"></i>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
<!-- Enables Add -->
        <div v-if="mode=='add'">
          <div class="row mt-3">
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <!-- Add User/Secret. -->
              <div class="p-1 rounded">
                <p class="fw-light text-white fs-5">Add Credential</p>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential" readonly>
                        <i class="fa-solid fa-lg fa-n"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" v-model="newName" style="cursor: text;" autocomplete="" placeholder="Credential Name (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential ">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential" readonly>
                        <i class="fa-solid fa-lg fa-id-badge"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" v-model="newAlias" style="cursor: text;" autocomplete="" placeholder="New Alias (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential ">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential || true" readonly>
                        <i class="fa-solid fa-lg fa-user"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" style="cursor: text;" autocomplete="" placeholder="New Username" :disabled="alteringCredential || addingCredential || deletingCredential || true " readonly>
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential" readonly>
                        <i class="fa-solid fa-lg fa-key"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="password" v-model="newPassword" style="cursor: text;" autocomplete="" placeholder="New Password" :disabled="alteringCredential || addingCredential || deletingCredential ">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential " readonly>
                        <i class="fa-solid fa-lg fa-check-double"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="password" v-model="newPasswordConfirm" style="cursor: text;" autocomplete="" placeholder="Password Confirmation" :disabled="alteringCredential || addingCredential || deletingCredential ">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1 mb-2">
                    <button class="btn btn-kraken fs-6 w-100" :disabled="alteringCredential || addingCredential || deletingCredential " @click="addCredential">
                      <i class="fa-solid fa-lg fa-plus" :class="{'fa-spin': addingCredential}"></i>
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>
<!-- Enables Edition -->
        <div v-if="mode=='edition'">
          <div class="row mt-3">
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <p class="fw-light text-white fs-5">Edit Credential</p>
              <!-- Enables # & Username -->
              <div class="input-group flex-nowrap">
                  <button class="btn btn-kraken fs-6" tabindex="-1" style="width: 10%" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential" readonly>
                    <i class="fa-solid fa-lg fa-arrow-down-1-9"></i>
                  </button>
                  <input class="btn border-bottom-kraken fw-light fs-6 text-white rounded me-2" style="width: 20%; cursor: default;" type="text" v-model="editionNumber" placeholder="#" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential" readonly>
                  <button class="btn btn-kraken fs-6 rounded" tabindex="-1" style="width: 15%" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || userlessCredentials.includes(selected_ctype)">
                    <i class="fa-solid fa-lg fa-user"></i>
                  </button>
                  <input class="btn border-bottom-kraken fw-light fs-6 text-white" type="text" :value="editionUsername" style="width: 54%; cursor: default;"  placeholder="Current Username" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || userlessCredentials.includes(selected_ctype)" readonly>
              </div>
              <!-- Enables Name -->
              <div class="input-group flex-nowrap mt-1">
                <button class="btn btn-kraken fs-6" style="width: 10%;" tabindex="-1" type="button"  :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                  <i class="fa-solid fa-lg fa-n"></i>
                </button>
                <input class="btn border-bottom-kraken fw-light fs-6 text-white" type="text" v-model="editionName" style="width: 90%; cursor: default;" autocomplete="" placeholder="Credential Name (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
              </div>
              <!-- Enables Alias -->
              <div class="input-group flex-nowrap mt-1">
                <button class="btn btn-kraken fs-6" style="width: 10%;" tabindex="-1" type="button"  :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                  <i class="fa-solid fa-lg fa-id-badge"></i>
                </button>
                <input class="btn border-bottom-kraken fw-light fs-5 text-white" type="text" v-model="editionAlias" style="width: 90%; cursor: default;" autocomplete="" placeholder="Credential Alias (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
              </div>
              <!-- Enables Current Secret -->
              <div class="input-group flex-nowrap mt-1">
                <button class="btn btn-kraken fs-6" style="width: 10%" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || true">
                  <i class="fa-solid fa-lg fa-key me-2"></i>
                </button>
                <input class="btn border-bottom-kraken fw-light fs-6 text-white"  type="text" :value="editionCurrentPassword" style="width: 90%; cursor: default;"  placeholder="Current Password" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || true" readonly>
              </div>
              <div class="mt-1">
                  <form class="w-100 input-group flex-nowrap">
                    <button class="btn btn-kraken fs-6" style="width: 10%" type="button"  :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                      <i class="fa-solid fa-lg fa-check-double"></i>
                    </button>
                    <div class="" style="width: 90%;">
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white mb-1" type="password" v-model="editionNewPassword" style="width: 100%; cursor: default;" autocomplete="" placeholder="New Password" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white" type="password" v-model="editionNewPasswordConfirm" style="width: 100%; cursor: default;" autocomplete=""  placeholder="Password Confirmation" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                    </div>
                  </form>
              </div>
              <div class="input-group flew-nowrap mt-1 mb-2">
                  <button class="btn btn-kraken fs-6 w-100" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential" @click="editCredential">
                    <i class="fa-solid fa-lg fa-pen" :class="{'fa-beat': alteringCredential}"></i>
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div> 

<!-- N E T W O R K  E L E M E N T S -->
      <div class="" v-if="selected_ctype == 'network_elements' && credentialsReady">
<!-- NE's Header -->
        <div class="input-group flex-nowrap">
          <input type="text" class="btn text-white fs-5 w-50 text-start border-bottom-kraken me-1" :class="{'w-50': mode=='main', 'w-100': mode != 'main'}" style="opacity: 1;" value="Network Elements Credentials" disabled>
          <select v-show="mode=='main'" class="btn btn-kraken bg-gradient text-white fs-5 text-start border-bottom-kraken rounded" style="width:35%;" v-model="search_by">
            <option value="name">Filter by name</option>
            <option value="alias">Filter by alias</option>
            <option value="username">Filter by username</option>
          </select>
          <input v-show="mode=='main'" type="text" class="btn text-white fs-5 w-50 text-start border-bottom-kraken me-1" style="opacity: 1; cursor: text;" v-model="search_word" placeholder="...">
          <button v-if="mode=='main'" class="btn btn-kraken bg-gradient fs-5 rounded" @click="selected_ctype='network_elements'; mode='add';">
            <i class="fa-solid fa-plus"></i>
          </button>
          <button v-if="mode=='add'" class="btn btn-suite-danger bg-gradient fs-5 rounded" @click="selected_ctype='network_elements'; mode='main'; clear();">
            <i class="fa-solid fa-close" :class="{'fa-beat-fade': mode=='add'}"></i>
          </button>
          <button v-if="mode=='edition'" class="btn btn-suite-danger bg-gradient fs-5 rounded" @click="selected_ctype='network_elements'; mode='main'; clear();">
            <i class="fa-solid fa-close" :class="{'fa-beat-fade': mode=='edition'}"></i>
          </button>
        </div>
<!-- NE's Table -->
        <div v-if="mode=='main'" class="mt-2">
          <div class="row">
            <div class="col-md-12">
              <!-- Table Header -->
              <div class="input-group flex-nowrap" style="pointer-events:none; overflow-y: scroll;">
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 5%;" value="#" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 30%;" value="Name" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 30%;" value="Alias" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 25%;" value="Username" readonly>
                <button class="btn btn-kraken rounded fs-6 me-1" style="width: 5%;" readonly>
                  <i class="fa-solid fa-lg fa-pen"></i>
                </button>
                <button class="btn btn-kraken rounded fs-6" style="width: 5%;" readonly>
                  <i class="fa-solid fa-lg fa-trash"></i>
                </button>
              </div>
              <!-- Table Content -->
              <div class="mt-1" style="height: 445px; overflow-y: scroll;">
                <div class="input-group flex-nowrap mb-1" v-for="(c, i) in filteredCreds" v-bind:key="i+1">
                  <input type="text" class="btn border-bottom-kraken text-white fs-6 me-1" style="width: 5%; cursor: text; pointer-events: none;" :value="i+1" readonly>
                  <input type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 30%; cursor: text; pointer-events: none;" :value="c.name" readonly>
                  <input type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 30%; cursor: text; pointer-events: none;" :value="c.alias" readonly>
                  <input v-if="c.username != null" type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 25%; cursor: text; pointer-events: none;" :value="c.username" readonly>
                  <input v-if="c.username == null" type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 25%; cursor: text; pointer-events: none;" value="-" readonly>
                  <button class="btn btn-kraken bg-gradient rounded fs-6 me-1" @click="setEdition(c, i+1)" style="width: 5%;">
                    <i class="fa-solid fa-lg fa-pen"></i>
                  </button>
                  <button class="btn btn-danger bg-gradient rounded fs-6" style="width: 5%; color: black; text-shadow: 3px 5px 4px rgb(180,0,0);" @click="deleteCredential(c, i+1)">
                    <i class="fa-solid fa-lg fa-trash"></i>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
<!-- NE's Add -->
        <div v-if="mode=='add'">
          <div class="row mt-3">
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <!-- Add User/Secret. -->
              <div class="bg-black p-1 rounded">
                <p class="fw-light text-white fs-5">Add Credential</p>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential" readonly>
                        <i class="fa-solid fa-lg fa-n"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" v-model="newName" style="cursor: text;" autocomplete="" placeholder="Credential Name (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential ">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential" readonly>
                        <i class="fa-solid fa-lg fa-id-badge"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" v-model="newAlias" style="cursor: text;" autocomplete="" placeholder="New Alias (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential ">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential" readonly>
                        <i class="fa-solid fa-lg fa-user"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" v-model="newUsername" style="cursor: text;" autocomplete="" placeholder="New Username" :disabled="alteringCredential || addingCredential || deletingCredential">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential" readonly>
                        <i class="fa-solid fa-lg fa-key"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="password" v-model="newPassword" style="cursor: text;" autocomplete="" placeholder="New Password" :disabled="alteringCredential || addingCredential || deletingCredential ">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential " readonly>
                        <i class="fa-solid fa-lg fa-check-double"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="password" v-model="newPasswordConfirm" style="cursor: text;" autocomplete="" placeholder="Password Confirmation" :disabled="alteringCredential || addingCredential || deletingCredential ">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1 mb-2">
                    <button class="btn btn-kraken fs-6 w-100" :disabled="alteringCredential || addingCredential || deletingCredential " @click="addCredential">
                      <i class="fa-solid fa-lg fa-plus" :class="{'fa-spin': addingCredential}"></i>
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>
<!-- NE's Edition -->
        <div v-if="mode=='edition'">
          <div class="row mt-3">
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <p class="fw-light text-white fs-5">Edit Credential</p>
              <!-- # & Username -->
              <div class="input-group flex-nowrap">
                  <button class="btn btn-kraken fs-6" tabindex="-1" style="width: 10%" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential" readonly>
                    <i class="fa-solid fa-lg fa-arrow-down-1-9"></i>
                  </button>
                  <input class="btn border-bottom-kraken fw-light fs-6 text-white rounded me-2" style="width: 20%; cursor: text;" type="text" v-model="editionNumber" placeholder="#" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential" readonly>
                  <button class="btn btn-kraken fs-6 rounded" tabindex="-1" style="width: 15%" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || userlessCredentials.includes(selected_ctype)">
                    <i class="fa-solid fa-lg fa-user"></i>
                  </button>
                  <input class="btn border-bottom-kraken fw-light fs-6 text-white" type="text" :value="editionUsername" style="width: 54%; cursor: text;"  placeholder="Current Username" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || userlessCredentials.includes(selected_ctype)" readonly>
              </div>
              <!-- Name -->
              <div class="input-group flex-nowrap mt-1">
                <button class="btn btn-kraken fs-6" style="width: 10%;" tabindex="-1" type="button"  :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                  <i class="fa-solid fa-lg fa-n"></i>
                </button>
                <input class="btn border-bottom-kraken fw-light fs-6 text-white" type="text" v-model="editionName" style="width: 90%; cursor: text;" autocomplete="" placeholder="Credential Name (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
              </div>
              <!-- Alias -->
              <div class="input-group flex-nowrap mt-1">
                <button class="btn btn-kraken fs-6" style="width: 10%;" tabindex="-1" type="button"  :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                  <i class="fa-solid fa-lg fa-id-badge"></i>
                </button>
                <input class="btn border-bottom-kraken fw-light fs-6 text-white" type="text" v-model="editionAlias" style="width: 90%; cursor: text;" autocomplete="" placeholder="Credential Alias (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
              </div>
              <!-- Current Secret -->
              <div class="input-group flex-nowrap mt-1">
                <button class="btn btn-kraken fs-6" style="width: 10%" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || true">
                  <i class="fa-solid fa-lg fa-key"></i>
                </button>
                <input class="btn border-bottom-kraken fw-light fs-6 text-white"  type="text" :value="editionCurrentPassword" style="width: 90%; cursor: text;"  placeholder="Current Password" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || true" readonly>
              </div>
              <div class="mt-1">
                  <form class="w-100 input-group flex-nowrap">
                    <button class="btn btn-kraken fs-6" style="width: 10%" type="button"  :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                      <i class="fa-solid fa-lg fa-check-double"></i>
                    </button>
                    <div class="" style="width: 90%;">
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white mb-1" type="password" v-model="editionNewPassword" style="width: 100%; cursor: text;" autocomplete="" placeholder="New Password" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white" type="password" v-model="editionNewPasswordConfirm" style="width: 100%; cursor: text;" autocomplete=""  placeholder="Password Confirmation" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                    </div>
                  </form>
              </div>
              <div class="input-group flew-nowrap mt-1 mb-2">
                  <button class="btn btn-kraken fs-6 w-100" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential" @click="editCredential">
                    <i class="fa-solid fa-lg fa-pen" :class="{'fa-beat': alteringCredential}"></i>
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div> 

<!-- S E R V E R S -->
      <div class="" v-if="selected_ctype == 'servers' && credentialsReady">
<!-- Servers Header -->
        <div class="input-group flex-nowrap">
          <input type="text" class="btn text-white fs-5 w-50 text-start border-bottom-kraken me-1" :class="{'w-50': mode=='main', 'w-100': mode != 'main'}" style="opacity: 1;" value="Servers Credentials" disabled>
          <select v-show="mode=='main'" class="btn btn-kraken bg-gradient text-white fs-5 text-start border-bottom-kraken rounded" style="width:35%;" v-model="search_by">
            <option value="name">Filter by name</option>
            <option value="alias">Filter by alias</option>
            <option value="username">Filter by username</option>
          </select>
          <input v-show="mode=='main'" type="text" class="btn text-white fs-5 w-50 text-start border-bottom-kraken" style="opacity: 1; cursor: text;" v-model="search_word" placeholder="...">
          <button v-if="mode=='main'" class="btn btn-kraken bg-gradient fs-5 rounded" @click="selected_ctype='servers'; mode='add';">
            <i class="fa-solid fa-plus"></i>
          </button>
          <button v-if="mode=='add'" class="btn btn-suite-danger bg-gradient fs-5 rounded" @click="selected_ctype='servers'; mode='main'; clear();">
            <i class="fa-solid fa-close" :class="{'fa-beat-fade': mode=='add'}"></i>
          </button>
          <button v-if="mode=='edition'" class="btn btn-suite-danger bg-gradient fs-5 rounded" @click="selected_ctype='servers'; mode='main'; clear();">
            <i class="fa-solid fa-close" :class="{'fa-beat-fade': mode=='edition'}"></i>
          </button>
        </div>
<!-- Servers Table -->
        <div v-if="mode=='main'" class="mt-2">
          <div class="row">
            <div class="col-md-12">
              <!-- Enables Table Header -->
              <div class="input-group flex-nowrap" style="overflow-y: scroll; pointer-events:none;">
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 5%;" value="#" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 30%;" value="Name" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 30%;" value="Alias" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 25%;" value="Username" readonly>
                <button class="btn btn-kraken rounded fs-6 me-1" style="width: 5%;" readonly>
                  <i class="fa-solid fa-lg fa-pen"></i>
                </button>
                <button class="btn btn-kraken rounded fs-6" style="width: 5%;" readonly>
                  <i class="fa-solid fa-lg fa-trash"></i>
                </button>
              </div>
              <!-- Enables Table Content -->
              <div class="mt-1" style="height: 445px; overflow-y: scroll;">
                <div class="input-group flex-nowrap mb-1" v-for="(c, i) in filteredCreds" v-bind:key="i+1">
                  <input type="text" class="btn border-bottom-kraken text-white fs-6 me-1" style="width: 5%; cursor: text; pointer-events:none;" :value="i+1" readonly>
                  <input type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 30%; cursor: text; pointer-events:none;" :value="c.name" readonly>
                  <input type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 30%; cursor: text; pointer-events:none;" :value="c.alias" readonly>
                  <input v-if="c.username != null" type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 25%; cursor: text; pointer-events:none;" :value="c.username" readonly>
                  <input v-if="c.username == null" type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 25%; cursor: text; pointer-events:none;" value="-" readonly>
                  <button class="btn btn-kraken bg-gradient rounded fs-6 me-1" @click="setEdition(c, i+1)" style="width: 5%;">
                    <i class="fa-solid fa-lg fa-pen"></i>
                  </button>
                  <button class="btn btn-danger bg-gradient rounded fs-6" style="width: 5%; color: black; text-shadow: 3px 5px 4px rgb(180,0,0);" @click="deleteCredential(c, i+1)">
                    <i class="fa-solid fa-lg fa-trash"></i>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
<!-- Servers Add -->
        <div v-if="mode=='add'">
          <div class="row mt-3">
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <!-- Add User/Secret. -->
              <div class="p-1 rounded">
                <p class="fw-light text-white fs-5">Add Credential</p>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential" readonly>
                        <i class="fa-solid fa-lg fa-n"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" v-model="newName" style="cursor: text;" autocomplete="" placeholder="Credential Name (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential ">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential" readonly>
                        <i class="fa-solid fa-lg fa-id-badge"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" v-model="newAlias" style="cursor: text;" autocomplete="" placeholder="New Alias (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential ">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential" readonly>
                        <i class="fa-solid fa-lg fa-user"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" v-model="newUsername" style="cursor: text;" autocomplete="" placeholder="New Username" :disabled="alteringCredential || addingCredential || deletingCredential">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential" readonly>
                        <i class="fa-solid fa-lg fa-key"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="password" v-model="newPassword" style="cursor: text;" autocomplete="" placeholder="New Password" :disabled="alteringCredential || addingCredential || deletingCredential ">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential " readonly>
                        <i class="fa-solid fa-lg fa-check-double"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="password" v-model="newPasswordConfirm" style="cursor: text;" autocomplete="" placeholder="Password Confirmation" :disabled="alteringCredential || addingCredential || deletingCredential ">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1 mb-2">
                    <button class="btn btn-kraken fs-6 w-100" :disabled="alteringCredential || addingCredential || deletingCredential " @click="addCredential">
                      <i class="fa-solid fa-lg fa-plus" :class="{'fa-spin': addingCredential}"></i>
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>
<!-- Servers Edition -->
        <div v-if="mode=='edition'">
          <div class="row mt-3">
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <p class="fw-light text-white fs-5">Edit Credential</p>
              <!-- Username -->
              <div class="input-group flex-nowrap">
                  <button class="btn btn-kraken fs-6" tabindex="-1" style="width: 10%" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential" readonly>
                    <i class="fa-solid fa-lg fa-arrow-down-1-9"></i>
                  </button>
                  <input class="btn border-bottom-kraken fw-light fs-6 text-white rounded me-2" style="width: 20%; cursor: text;" type="text" v-model="editionNumber" placeholder="#" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential" readonly>
                  <button class="btn btn-kraken fs-6 rounded" tabindex="-1" style="width: 15%" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || userlessCredentials.includes(selected_ctype)">
                    <i class="fa-solid fa-lg fa-user"></i>
                  </button>
                  <input class="btn border-bottom-kraken fw-light fs-6 text-white" type="text" :value="editionUsername" style="width: 54%; cursor: text;"  placeholder="Current Username" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || userlessCredentials.includes(selected_ctype)" readonly>
              </div>
              <!-- Name -->
              <div class="input-group flex-nowrap mt-1">
                <button class="btn btn-kraken fs-6" style="width: 10%;" tabindex="-1" type="button"  :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                  <i class="fa-solid fa-lg fa-n"></i>
                </button>
                <input class="btn border-bottom-kraken fw-light fs-6 text-white" type="text" v-model="editionName" style="width: 90%; cursor: text;" autocomplete="" placeholder="Credential Name (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
              </div>
              <!-- Alias -->
              <div class="input-group flex-nowrap mt-1">
                <button class="btn btn-kraken fs-6" style="width: 10%;" tabindex="-1" type="button"  :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                  <i class="fa-solid fa-lg fa-id-badge"></i>
                </button>
                <input class="btn border-bottom-kraken fw-light fs-6 text-white" type="text" v-model="editionAlias" style="width: 90%; cursor: text;" autocomplete="" placeholder="Credential Alias (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
              </div>
              <!-- Current Secret -->
              <div class="input-group flex-nowrap mt-1">
                <button class="btn btn-kraken fs-6" style="width: 10%" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || true">
                  <i class="fa-solid fa-lg fa-key"></i>
                </button>
                <input class="btn border-bottom-kraken fw-light fs-6 text-white"  type="text" :value="editionCurrentPassword" style="width: 90%; cursor: text;"  placeholder="Current Password" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || true" readonly>
              </div>
              <div class="mt-1">
                  <form class="w-100 input-group flex-nowrap">
                    <button class="btn btn-kraken fs-6" style="width: 10%" type="button"  :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                      <i class="fa-solid fa-lg fa-check-double"></i>
                    </button>
                    <div class="" style="width: 90%;">
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white mb-1" type="password" v-model="editionNewPassword" style="width: 100%; cursor: text;" autocomplete="" placeholder="New Password" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white" type="password" v-model="editionNewPasswordConfirm" style="width: 100%; cursor: text;" autocomplete=""  placeholder="Password Confirmation" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                    </div>
                  </form>
              </div>
              <div class="input-group flew-nowrap mt-1 mb-2">
                  <button class="btn btn-kraken fs-6 w-100" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential" @click="editCredential">
                    <i class="fa-solid fa-lg fa-pen" :class="{'fa-beat': alteringCredential}"></i>
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div> 

<!-- T A C A C S  S K -->
      <div class="" v-if="selected_ctype == 'tacacs_sk' && credentialsReady">
<!-- Tacacs SK Header -->
        <div class="input-group flex-nowrap">
          <input type="text" class="btn text-white fs-5 w-50 text-start border-bottom-kraken" :class="{'w-50': mode=='main', 'w-100': mode != 'main'}" style="opacity: 1;" value="Tacacs Secret Key" disabled>
          <select v-show="mode=='main'" class="btn btn-kraken bg-gradient text-white fs-5 text-start rounded" style="width:35%;" v-model="search_by">
            <option value="name">Filter by name</option>
            <option value="alias">Filter by alias</option>
          </select>
          <input v-show="mode=='main'" type="text" class="btn text-white fs-5 w-50 text-start border-bottom-kraken" style="opacity: 1; cursor: text;" v-model="search_word" placeholder="...">
          <button v-if="mode=='main'" class="btn btn-kraken bg-gradient fs-5 rounded" @click="selected_ctype='tacacs_sk'; mode='add';" :disabled="credentials.length > 0">
            <i class="fa-solid fa-plus"></i>
          </button>
          <button v-if="mode=='add'" class="btn btn-suite-danger bg-gradient fs-3 rounded" @click="selected_ctype='tacacs_sk'; mode='main'; clear();">
            <i class="fa-solid fa-close"></i>
          </button>
          <button v-if="mode=='edition'" class="btn btn-suite-danger bg-gradient fs-3 rounded" @click="selected_ctype='tacacs_sk'; mode='main'; clear();">
            <i class="fa-solid fa-close"></i>
          </button>
        </div>
<!-- Tacacs SK Table -->
        <div v-if="mode=='main'" class="mt-2">
          <div class="row">
            <div class="col-md-12">
              <!-- Enables Table Header -->
              <div class="input-group flex-nowrap" style="pointer-events: none; overflow-y: scroll;">
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 5%;" value="#" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 30%;" value="Name" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 30%;" value="Alias" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 25%;" value="Username" readonly>
                <button class="btn btn-kraken rounded fs-6 me-1" style="width: 5%;" readonly>
                  <i class="fa-solid fa-lg fa-pen"></i>
                </button>
                <button class="btn btn-kraken rounded fs-6" style="width: 5%;" readonly>
                  <i class="fa-solid fa-lg fa-trash"></i>
                </button>
              </div>
              <!-- Enables Table Content -->
              <div class="mt-1" style="height: 445px; overflow-y: scroll;">
                <div class="input-group flex-nowrap mb-1" v-for="(c, i) in filteredCreds" v-bind:key="i+1">
                  <input type="text" class="btn border-bottom-kraken text-white fs-6 me-1" style="width: 5%; cursor: text; pointer-events: none;" :value="i+1" readonly>
                  <input type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 30%; cursor: text; pointer-events: none;" :value="c.name" readonly>
                  <input type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 30%; cursor: text; pointer-events: none;" :value="c.alias" readonly>
                  <input v-if="c.username != null" type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 25%; cursor: text; pointer-events: none;" :value="c.username" readonly>
                  <input v-if="c.username == null" type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 25%; cursor: text;pointer-events: none;" value="-" readonly>
                  <button class="btn btn-kraken bg-gradient rounded fs-6 me-1" @click="setEdition(c, i+1)" style="width: 5%;">
                    <i class="fa-solid fa-lg fa-pen"></i>
                  </button>
                  <button class="btn btn-danger bg-gradient rounded fs-6" style="width: 5%; color: black; text-shadow: 3px 5px 4px rgb(180,0,0);" @click="deleteCredential(c, i+1)">
                    <i class="fa-solid fa-lg fa-trash"></i>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
<!-- Tacacs SK Add -->
        <div v-if="mode=='add' && credentials.length == 0">
          <div class="row mt-3">
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <!-- Add User/Secret. -->
              <div class="bg-black p-1 rounded">
                <p class="fw-light text-white fs-5">Add Secret Key</p>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential" readonly>
                        <i class="fa-solid fa-lg fa-n"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" v-model="newName" style="cursor: text;" autocomplete="" placeholder="Key Name (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential ">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential" readonly>
                        <i class="fa-solid fa-lg fa-id-badge"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" v-model="newAlias" style="cursor: text;" autocomplete="" placeholder="Key Alias (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential ">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential || true" readonly>
                        <i class="fa-solid fa-lg fa-user"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" style="cursor: text;" autocomplete="" placeholder="New Username" :disabled="alteringCredential || addingCredential || deletingCredential || true" readonly>
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential" readonly>
                        <i class="fa-solid fa-lg fa-key"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="password" v-model="newPassword" style="cursor: text;" autocomplete="" placeholder="New Secret Key" :disabled="alteringCredential || addingCredential || deletingCredential ">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1">
                    <form class="w-100">
                      <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" :disabled="alteringCredential || addingCredential || deletingCredential " readonly>
                        <i class="fa-solid fa-lg fa-check-double"></i>
                      </button>
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="password" v-model="newPasswordConfirm" style="cursor: text;" autocomplete="" placeholder="New Secret Key Confirmation" :disabled="alteringCredential || addingCredential || deletingCredential ">
                    </form>
                </div>
                <div class="input-group flex-nowrap mt-1 mb-2">
                    <button class="btn btn-kraken fs-6 w-100" :disabled="alteringCredential || addingCredential || deletingCredential " @click="addCredential">
                      <i class="fa-solid fa-lg fa-plus" :class="{'fa-spin': addingCredential}"></i>
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>
<!-- Tacacs SK Edition -->
        <div v-if="mode=='edition'">
          <div class="row mt-3">
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <p class="fw-light text-white fs-5">Edit Credential</p>
              <!-- # & Username -->
              <div class="input-group flex-nowrap">
                  <button class="btn btn-kraken fs-6" tabindex="-1" style="width: 10%" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential" readonly>
                    <i class="fa-solid fa-lg fa-arrow-down-1-9"></i>
                  </button>
                  <input class="btn border-bottom-kraken fw-light fs-6 text-white rounded me-2" style="width: 20%; cursor: text;" type="text" v-model="editionNumber" placeholder="#" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential" readonly>
                  <button class="btn btn-kraken fs-6 rounded" tabindex="-1" style="width: 15%" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || userlessCredentials.includes(selected_ctype)">
                    <i class="fa-solid fa-lg fa-user"></i>
                  </button>
                  <input class="btn border-bottom-kraken fw-light fs-6 text-white" type="text" :value="editionUsername" style="width: 54%; cursor: text;"  placeholder="Current Username" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || userlessCredentials.includes(selected_ctype)" readonly>
              </div>
              <!-- Name -->
              <div class="input-group flex-nowrap mt-1">
                <button class="btn btn-kraken fs-6" style="width: 10%;" tabindex="-1" type="button"  :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                  <i class="fa-solid fa-lg fa-n"></i>
                </button>
                <input class="btn border-bottom-kraken fw-light fs-6 text-white" type="text" v-model="editionName" style="width: 90%; cursor: text;" autocomplete="" placeholder="Credential Name (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
              </div>
              <!-- Alias -->
              <div class="input-group flex-nowrap mt-1">
                <button class="btn btn-kraken fs-6" style="width: 10%;" tabindex="-1" type="button"  :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                  <i class="fa-solid fa-lg fa-id-badge"></i>
                </button>
                <input class="btn border-bottom-kraken fw-light fs-6 text-white" type="text" v-model="editionAlias" style="width: 90%; cursor: text;" autocomplete="" placeholder="Credential Alias (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
              </div>
              <!-- Current Secret -->
              <div class="input-group flex-nowrap mt-1">
                <button class="btn btn-kraken fs-6" style="width: 10%" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || true">
                  <i class="fa-solid fa-lg fa-key me-2"></i>
                </button>
                <input class="btn border-bottom-kraken fw-light fs-6 text-white"  type="text" :value="editionCurrentPassword" style="width: 90%; cursor: text;"  placeholder="Current Password" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || true" readonly>
              </div>
              <div class="mt-1">
                  <form class="w-100 input-group flex-nowrap">
                    <button class="btn btn-kraken fs-6" style="width: 10%" type="button"  :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                      <i class="fa-solid fa-lg fa-check-double"></i>
                    </button>
                    <div class="" style="width: 90%;">
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white mb-1" type="password" v-model="editionNewPassword" style="width: 100%; cursor: text;" autocomplete="" placeholder="New Secret Key" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                      <input class="btn border-bottom-kraken fw-light fs-6 text-white" type="password" v-model="editionNewPasswordConfirm" style="width: 100%; cursor: text;" autocomplete=""  placeholder="New Secret Key Confirmation" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                    </div>
                  </form>
              </div>
              <div class="input-group flew-nowrap mt-1 mb-2">
                  <button class="btn btn-kraken fs-6 w-100" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential" @click="editCredential">
                    <i class="fa-solid fa-lg fa-pen" :class="{'fa-beat': alteringCredential}"></i>
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div>


<!-- C L O U D  C R E D S -->
      <div class="" v-if="selected_ctype == 'cloud_credentials' && credentialsReady">
<!-- Cloud credentials  Header -->
        <div class="input-group flex-nowrap">
          <input type="text" class="btn text-white fs-5 w-50 text-start border-bottom-kraken me-1" :class="{'w-50': mode=='main', 'w-100': mode != 'main'}" style="opacity: 1;" value="Cloud Credentials" disabled>
          <select v-show="mode=='main'" class="btn btn-kraken bg-gradient text-white fs-5 text-start border-bottom-kraken rounded" style="width:35%;" v-model="search_by">
            <option value="name">Filter by name</option>
            <option value="alias">Filter by alias</option>
          </select>
          <input v-show="mode=='main'" type="text" class="btn text-white fs-5 w-50 text-start border-bottom-kraken" style="opacity: 1; cursor: text;" v-model="search_word" placeholder="...">
          <button v-if="mode=='main'" class="btn btn-kraken bg-gradient fs-5 rounded" @click="selected_ctype='cloud_credentials'; mode='add';">
            <i class="fa-solid fa-plus"></i>
          </button>
          <button v-if="mode=='add'" class="btn btn-kraken-danger bg-gradient fs-5 rounded" @click="selected_ctype='cloud_credentials'; mode='main'; clear();">
            <i class="fa-solid fa-close" :class="{'fa-beat-fade': mode=='add'}"></i>
          </button>
          <button v-if="mode=='edition'" class="btn btn-kraken-danger bg-gradient fs-5 rounded" @click="selected_ctype='cloud_credentials'; mode='main'; clear();">
            <i class="fa-solid fa-close" :class="{'fa-beat-fade': mode=='edition'}"></i>
          </button>
        </div>
<!-- Cloud credentials Table -->
        <div v-if="mode=='main'" class="mt-2">
          <div class="row">
            <div class="col-md-12">
              <div class="input-group flex-nowrap" style="overflow-y: scroll; pointer-events:none;">
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 5%;" value="#" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 25%;" value="Name" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 20%;" value="Alias" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 15%;" value="Type" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 25%;" value="Username" readonly>
                <button class="btn btn-kraken rounded fs-6 me-1" style="width: 5%;" readonly>
                  <i class="fa-solid fa-lg fa-info"></i>
                </button>
                <button class="btn btn-kraken rounded fs-6" style="width: 5%;" readonly>
                  <i class="fa-solid fa-lg fa-trash"></i>
                </button>
              </div>
              <!-- Enables Table Content -->
              <div class="mt-1" style="height: 445px; overflow-y: scroll;">
                <div class="input-group flex-nowrap mb-1" v-for="(c, i) in filteredCreds" v-bind:key="i+1">
                  <input type="text" class="btn border-bottom-kraken text-white fs-6 me-1" style="width: 5%; cursor: text; pointer-events:none;" :value="i+1" readonly>
                  <input type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 25%; cursor: text; pointer-events:none;" :value="c.name" readonly>
                  <input type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 20%; cursor: text; pointer-events:none;" :value="c.alias" readonly>
                  <input type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 15%; cursor: text; pointer-events:none;" :value="c.cloud_technology" readonly>
                  <input v-if="c.username != null" type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 25%; cursor: text; pointer-events:none;" :value="c.username" readonly>
                  <input v-if="c.username == null" type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 25%; cursor: text; pointer-events:none;" value="-" readonly>
                  <button class="btn btn-kraken bg-gradient rounded fs-6 me-1" @click="setCloudEdition(c)" style="width: 5%;">
                    <i class="fa-solid fa-lg fa-eye"></i>
                  </button>
                  <button class="btn btn-danger bg-gradient rounded fs-6" style="width: 5%; color: black; text-shadow: 3px 5px 4px rgb(180,0,0);" @click="deleteCredential(c, i+1)">
                    <i class="fa-solid fa-lg fa-trash"></i>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
<!-- Cloud credentials Add & Edition -->
        <div v-if="mode=='add' || mode == 'edition'">
          <!-- Cloud credentials header. -->
          <div class="row mt-3" :class="{'disabled-div': addingCredential }">
            <div class="col-md-3">
              <p v-if="mode == 'add'" class="fw-light text-white ms-3 fs-5">Add Cloud Credential</p>
              <p v-if="mode == 'edition'" class="fw-light text-white ms-3 fs-5">View Cloud Credential</p>
            </div>
            <div class="col-md-3">
              <div class="input-group flex-nowrap">
                  <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" readonly>
                    <i class="fa-solid fa-lg fa-cloud"></i>
                  </button>
                  <select class="btn border-bottom-kraken fw-light fs-6 text-white w-75" v-model="cloud_technology" @change="clear();" :disabled="mode=='edition'">
                    <option value="meraki">Meraki</option>
                    <option v-if="false" value="aruba">Aruba</option>
                  </select>
                </div>
            </div>
            <div class="col-md-3">
              <div class="input-group flex-nowrap mt-1">
                  <form class="w-100">
                    <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" readonly>
                      <i class="fa-solid fa-lg fa-n"></i>
                    </button>
                    <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" v-model="newName" style="cursor: text;" autocomplete="" placeholder="Name" :disabled="mode == 'edition'">
                  </form>
              </div>
            </div>
            <div class="col-md-3">
              <div class="input-group flex-nowrap mt-1">
                <form class="w-100">
                  <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" readonly>
                    <i class="fa-solid fa-lg fa-id-badge"></i>
                  </button>
                  <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" v-model="newAlias" style="cursor: text;" autocomplete="" placeholder="Alias" :disabled="mode == 'edition'">
                </form>
              </div>
            </div>
          </div>
          <!-- Meraki -->
          <div v-if="cloud_technology == 'meraki'" class="row mt-5" :class="{'disabled-div': addingCredential || mode=='edition' }">
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <div class="input-group flex-nowrap mt-1">
                  <form class="w-100">
                    <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button"  readonly>
                      <i class="fa-solid fa-lg fa-key"></i>
                    </button>
                    <input v-if="mode=='add'" class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="password" v-model="credentials_types.cloud_credentials.meraki.key" style="cursor: text;" autocomplete="" placeholder="New API Key">
                    <input v-if="mode=='edition'" class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="password" :value="'*****'" style="cursor: text;" autocomplete="" placeholder="New API Key">
                  </form>
              </div>
              <div v-if="mode!='edition'" class="input-group flex-nowrap mt-1">
                  <form class="w-100">
                    <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" readonly>
                      <i class="fa-solid fa-lg fa-check-double"></i>
                    </button>
                    <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="password" v-model="credentials_types.cloud_credentials.meraki.key_confirm" style="cursor: text;" autocomplete="" placeholder="New API Key Confirmation">
                  </form>
              </div>
              <div class="input-group flex-nowrap mt-1 mb-2">
                  <button v-if="mode=='add'" class="btn btn-kraken fs-6 w-100" :disabled="addingCredential" @click="addCredential">
                    <i class="fa-solid fa-lg fa-plus" :class="{'fa-spin': addingCredential}"></i>
                  </button>
              </div>
            </div>
          </div>
          <!-- Aruba -->
          <div v-if="cloud_technology == 'aruba'" class="row mt-5" :class="{'disabled-div': addingCredential || mode=='edition' }">
            <div class="col-md-1"></div>
            <div class="col-md-5">
              <div class="input-group flex-nowrap mt-1">
                  <form class="w-100">
                    <button class="btn btn-kraken fs-5 w-25" tabindex="-1" style="cursor: default;" type="button" readonly>
                      <i class="fa-solid fa-lg fa-user"></i>
                    </button>
                    <input class="btn border-bottom-kraken fw-light fs-5 text-white w-75" type="text" v-model="credentials_types.cloud_credentials.aruba.username" style="cursor: text;" autocomplete="" placeholder="Username">
                  </form>
              </div>
              <div class="input-group flex-nowrap mt-1">
                  <form class="w-100">
                    <button class="btn btn-kraken fs-5 w-25" tabindex="-1" style="cursor: default;" type="button" readonly>
                      <i class="fa-solid fa-lg fa-key"></i>
                    </button>
                    <input v-if="mode=='add'" class="btn border-bottom-kraken fw-light fs-5 text-white w-75" type="password" v-model="credentials_types.cloud_credentials.aruba.password" style="cursor: text;" autocomplete="" placeholder="Password" >
                    <input v-if="mode=='edition'" class="btn border-bottom-kraken fw-light fs-5 text-white w-75" type="password" :value="'*****'" style="cursor: text;" autocomplete="">
                  </form>
              </div>
              <div class="input-group flex-nowrap mt-1">
                  <form class="w-100">
                    <button class="btn btn-kraken fs-5 w-25" tabindex="-1" style="cursor: default;" type="button" readonly>
                      <i class="fa-solid fa-lg fa-check-double"></i>
                    </button>
                    <input class="btn border-bottom-kraken fw-light fs-5 text-white w-75" type="password" v-model="credentials_types.cloud_credentials.aruba.password_confirm" style="cursor: text;" autocomplete="" placeholder="Password confirmation.">
                  </form>
              </div>
            </div>
            <div class="col-md-5">
              <div class="input-group flex-nowrap mt-1">
                  <form class="w-100">
                    <button class="btn btn-kraken fs-5 w-25" tabindex="-1" style="cursor: default;" type="button" readonly>
                      <i class="fa-solid fa-lg fa-id-card"></i>
                    </button>
                    <input class="btn border-bottom-kraken fw-light fs-5 text-white w-75" type="text" v-model="credentials_types.cloud_credentials.aruba.client_id" style="cursor: text;" autocomplete="" placeholder="Client ID">
                  </form>
              </div>
              <div class="input-group flex-nowrap mt-1">
                  <form class="w-100">
                    <button class="btn btn-kraken fs-5 w-25" tabindex="-1" style="cursor: default;" type="button" readonly>
                      <i class="fa-solid fa-lg fa-user-secret"></i>
                    </button>
                    <input v-if="mode=='add'"  class="btn border-bottom-kraken fw-light fs-5 text-white w-75" type="password" v-model="credentials_types.cloud_credentials.aruba.client_secret" style="cursor: text;" autocomplete="" placeholder="Secret">
                    <input v-if="mode=='edition'" class="btn border-bottom-kraken fw-light fs-5 text-white w-75" type="password" :value="'*****'" style="cursor: text;" autocomplete="">
                  </form>
              </div>
              <div class="input-group flex-nowrap mt-1">
                  <form class="w-100">
                    <button class="btn btn-kraken fs-5 w-25" tabindex="-1" style="cursor: default;" type="button" readonly>
                      <i class="fa-solid fa-lg fa-leaf"></i>
                    </button>
                    <input class="btn border-bottom-kraken fw-light fs-5 text-white w-75" type="text" v-model="credentials_types.cloud_credentials.aruba.customer_id" style="cursor: text;" autocomplete="" placeholder="Customer ID">
                  </form>
              </div>
            </div>
            <div class="col-md-1"></div>
            <!-- Add button -->
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <div class="input-group flex-nowrap mt-1 mb-2">
                  <button v-if="mode=='add'" class="btn btn-kraken fs-5 w-100" :disabled="alteringCredential || addingCredential || deletingCredential " @click="addCredential">
                    <i class="fa-solid fa-lg fa-plus" :class="{'fa-spin': addingCredential}"></i>
                  </button>
              </div>
            </div>
          </div>
        </div>
<!-- Cloud credentials Edition -->
        <div v-if="mode=='__edition'">
          <div class="row mt-3">
            <div class="col-md-3"></div>
            <div class="col-md-6">
              <p class="fw-light text-white fs-4">Edit Credential</p>
              <!-- # & Username -->
              <div class="input-group flex-nowrap">
                  <button class="btn btn-kraken fs-5" tabindex="-1" style="width: 10%" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential" readonly>
                    <i class="fa-solid fa-lg fa-arrow-down-1-9"></i>
                  </button>
                  <input class="btn border-bottom-kraken fw-light fs-5 text-white rounded me-2" style="width: 20%; cursor: text;" type="text" v-model="editionNumber" placeholder="#" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential" readonly>
                  <button class="btn btn-kraken fs-5 rounded" tabindex="-1" style="width: 15%" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || userlessCredentials.includes(selected_ctype)">
                    <i class="fa-solid fa-lg fa-user"></i>
                  </button>
                  <input class="btn border-bottom-kraken fw-light fs-5 text-white" type="text" :value="editionUsername" style="width: 54%; cursor: text;"  placeholder="Current Username" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || userlessCredentials.includes(selected_ctype)" readonly>
              </div>
              <!-- Name -->
              <div class="input-group flex-nowrap mt-1">
                <button class="btn btn-kraken fs-5" style="width: 10%;" tabindex="-1" type="button"  :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                  <i class="fa-solid fa-lg fa-n"></i>
                </button>
                <input class="btn border-bottom-kraken fw-light fs-5 text-white" type="text" v-model="editionName" style="width: 90%; cursor: text;" autocomplete="" placeholder="Credential Name (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
              </div>
              <!-- Alias -->
              <div class="input-group flex-nowrap mt-1">
                <button class="btn btn-kraken fs-5" style="width: 10%;" tabindex="-1" type="button"  :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                  <i class="fa-solid fa-lg fa-id-badge"></i>
                </button>
                <input class="btn border-bottom-kraken fw-light fs-5 text-white" type="text" v-model="editionAlias" style="width: 90%; cursor: text;" autocomplete="" placeholder="Credential Alias (Reference only)" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
              </div>
              <!-- Current Secret -->
              <div class="input-group flex-nowrap mt-1">
                <button class="btn btn-kraken fs-5" style="width: 10%" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || true">
                  <i class="fa-solid fa-lg fa-key me-2"></i>
                </button>
                <input class="btn border-bottom-kraken fw-light fs-5 text-white"  type="text" :value="editionCurrentPassword" style="width: 90%; cursor: text;"  placeholder="Current Password" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential || true" readonly>
              </div>
              <div class="mt-1">
                  <form class="w-100 input-group flex-nowrap">
                    <button class="btn btn-kraken fs-5" style="width: 10%" type="button"  :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                      <i class="fa-solid fa-lg fa-check-double"></i>
                    </button>
                    <div class="" style="width: 90%;">
                      <input class="btn border-bottom-kraken fw-light fs-5 text-white mb-1" type="password" v-model="editionNewPassword" style="width: 100%; cursor: text;" autocomplete="" placeholder="New Secret Key" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                      <input class="btn border-bottom-kraken fw-light fs-5 text-white" type="password" v-model="editionNewPasswordConfirm" style="width: 100%; cursor: text;" autocomplete=""  placeholder="New Secret Key Confirmation" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential">
                    </div>
                  </form>
              </div>
              <div class="input-group flew-nowrap mt-1 mb-2">
                  <button class="btn btn-kraken fs-5 w-100" :disabled="alteringCredential || addingCredential || deletingCredential || !editingCredential" @click="editCredential">
                    <i class="fa-solid fa-lg fa-pen" :class="{'fa-beat': alteringCredential}"></i>
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div>

<!-- S N M P   C R E D S -->
      <div class="" v-if="selected_ctype == 'snmp_credentials' && credentialsReady">
<!-- SNMP Creds Header -->
        <div class="input-group flex-nowrap">
          <input type="text" class="btn text-white fs-5 w-50 text-start border-bottom-kraken me-1" :class="{'w-50': mode=='main', 'w-100': mode != 'main'}" style="opacity: 1;" value="SNMP Credentials" disabled>
          <select v-show="mode=='main'" class="btn btn-kraken bg-gradient text-white fs-5 text-start border-bottom-kraken rounded" style="width:35%;" v-model="search_by">
            <option value="name">Filter by name</option>
            <option value="alias">Filter by alias</option>
          </select>
          <input v-show="mode=='main'" type="text" class="btn text-white fs-5 w-50 text-start border-bottom-kraken me-1" style="opacity: 1; cursor: text;" v-model="search_word" placeholder="...">
          <button v-if="mode=='main'" class="btn btn-kraken bg-gradient fs-5 rounded" @click="selected_ctype='snmp_credentials'; mode='add';">
            <i class="fa-solid fa-plus"></i>
          </button>
          <button v-if="mode=='add'" class="btn btn-kraken-danger bg-gradient fs-5 rounded" @click="selected_ctype='snmp_credentials'; mode='main'; clear();">
            <i class="fa-solid fa-close" :class="{'fa-beat-fade': mode=='add'}"></i>
          </button>
          <button v-if="mode=='edition'" class="btn btn-kraken-danger bg-gradient fs-5 rounded" @click="selected_ctype='snmp_credentials'; mode='main'; clear();">
            <i class="fa-solid fa-close" :class="{'fa-beat-fade': mode=='edition'}"></i>
          </button>
        </div>
<!-- SNMP Creds Table -->
        <div v-if="mode=='main'" class="mt-2">
          <div class="row">
            <div class="col-md-12">
              <!-- Enables Table Header -->
              <div class="input-group flex-nowrap" style="overflow-y: scroll;">
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 5%;" value="#" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 30%;" value="Name" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 30%;" value="Alias" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 10%;" value="Version" readonly>
                <input type="text" class="btn btn-kraken rounded fs-6 me-1" style="width: 25%;" value="Username/Community" readonly>
                <button class="btn btn-kraken rounded fs-6 me-1" style="width: 5%;" readonly>
                  <i class="fa-solid fa-lg fa-pen"></i>
                </button>
                <button class="btn btn-kraken rounded fs-6" style="width: 5%;" readonly>
                  <i class="fa-solid fa-lg fa-trash"></i>
                </button>
              </div>
              <!-- Enables Table Content -->
              <div class="mt-1" style="height: 445px; overflow-y: scroll;">
                <div class="input-group flex-nowrap mb-1" v-for="(c, i) in filteredCreds" v-bind:key="i+1">
                  <input type="text" class="btn border-bottom-kraken text-white fs-6 me-1" style="width: 5%; cursor: text;" :value="i+1" readonly>
                  <input type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 30%; cursor: text;" :value="c.name" readonly>
                  <input type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 30%; cursor: text;" :value="c.alias" readonly>
                  <input type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 10%; cursor: text;" :value="c.snmp_version" readonly>
                  <input v-if="c.username != null" type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 25%; cursor: text;" :value="c.username" readonly>
                  <input v-if="c.username == null" type="text" class="btn border-bottom-kraken text-white rounded fs-6 me-1" style="width: 25%; cursor: text;" value="-" readonly>
                  <button class="btn btn-kraken bg-gradient rounded fs-6 me-1" @click="setEdition(c, i+1)" style="width: 5%;">
                    <i class="fa-solid fa-lg fa-pen"></i>
                  </button>
                  <button class="btn btn-danger bg-gradient rounded fs-6" style="width: 5%; color: black; text-shadow: 3px 5px 4px rgb(180,0,0);" @click="deleteCredential(c, i+1)">
                    <i class="fa-solid fa-lg fa-trash"></i>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

<!-- SNMP Creds Add -->
        <div v-if="mode=='add' || mode == 'edition'">
          <!-- SNMP credentials addition header. -->
          <div class="row mt-3" :class="{'disabled-div': addingCredential }">
            <div class="col-md-3">
              <p v-if="mode == 'add'" class="fw-light text-white ms-3 fs-5">Add SNMP Credential</p>
              <p v-if="mode == 'edition'" class="fw-light text-white ms-3 fs-5">View SNMP Credential</p>
            </div>
            <div class="col-md-3">
              <div class="input-group flex-nowrap">
                  <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default; pointer-events: none;" type="button" title="SNMP version." readonly>
                    <i class="fa-solid fa-lg fa-circle-nodes"></i>
                  </button>
                  <select class="btn border-bottom-kraken fw-light fs-6 text-white w-75" v-model="snmp_version" @change="clear();" title="SNMP version." :disabled="mode=='edition'">
                    <option value="v2">Version 2</option>
                    <option value="v3">Version 3</option>
                  </select>
                </div>
            </div>
            <div class="col-md-3">
              <div class="input-group flex-nowrap">
                  <form class="w-100">
                    <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" readonly>
                      <i class="fa-solid fa-lg fa-n"></i>
                    </button>
                    <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" v-model="newName" style="cursor: text;" autocomplete="" placeholder="Name" :disabled="mode == 'edition'">
                  </form>
              </div>
            </div>
            <div class="col-md-3">
              <div class="input-group flex-nowrap">
                <form class="w-100">
                  <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default;" type="button" readonly>
                    <i class="fa-solid fa-lg fa-id-badge"></i>
                  </button>
                  <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" v-model="newAlias" style="cursor: text;" autocomplete="" placeholder="Alias" :disabled="mode == 'edition'">
                </form>
              </div>
            </div>
          </div>
          <!-- Version 2 -->
          <div v-if="snmp_version == 'v2'" class="row mt-5" :class="{'disabled-div': addingCredential || mode=='edition' }">
            <div class="col-md-3"></div>
            <div class="col-md-6">
              <div class="input-group flex-nowrap mt-1">
                  <form class="w-100">
                    <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default; pointer-events:none;" type="button"  readonly>
                      <i class="fa-solid fa-lg fa-users"></i>
                    </button>
                    <input v-if="mode=='add'" class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" v-model="credentials_types.snmp_credentials.v2.community" style="cursor: text;" autocomplete="" placeholder="Community">
                    <input v-if="mode=='edition'" class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="password" :value="'*****'" style="cursor: text;" autocomplete="" placeholder="Community">
                  </form>
              </div>
              <div class="input-group flex-nowrap mt-1 mb-2">
                  <button v-if="mode=='add'" class="btn btn-kraken fs-6 w-100" :disabled="addingCredential" @click="addCredential">
                    <i class="fa-solid fa-lg fa-plus" :class="{'fa-fade': addingCredential}"></i>
                  </button>
              </div>
            </div>
          </div>
          <!-- Version 3 -->
          <div v-if="snmp_version == 'v3'" class="row mt-5" :class="{'disabled-div': addingCredential || mode=='edition' }">
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <div class="input-group flex-nowrap mt-1">
                  <form class="w-100">
                    <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default; pointer-events:none;" type="button" readonly>
                      <i class="fa-solid fa-lg fa-user"></i>
                    </button>
                    <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" v-model="credentials_types.snmp_credentials.v3.username" style="cursor: text;" autocomplete="" placeholder="Username">
                  </form>
              </div>
              <div class="input-group flex-nowrap mt-1">
                  <form class="w-100">
                    <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default; pointer-events:none;" type="button" readonly>
                      <i class="fa-solid fa-lg fa-gear"></i>
                    </button>
                    <input class="btn border-bottom-kraken fw-light fs-6 text-white w-75" type="text" v-model="credentials_types.snmp_credentials.v3.engineid" style="cursor: text;" autocomplete="" placeholder="Engine ID (Optional)">
                  </form>
              </div>
              <div class="input-group flex-nowrap mt-1">
                  <form class="w-100">
                    <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default; pointer-events:none;" type="button" readonly>
                      <i class="fa-solid fa-lg fa-user-lock"></i>
                    </button>
                    <select v-if="mode=='add'" class="btn border-bottom-kraken fw-light fs-6 text-white" style="cursor: pointer; width: 30%;" title="Auth. Protocol" v-model="credentials_types.snmp_credentials.v3.auth_protocol">
                      <option :value="null">Auth. Protocol</option>
                      <option value="md5">MD5</option>
                      <option value="sha">SHA</option>
                    </select>
                    <input v-if="mode=='add'" class="btn border-bottom-kraken fw-light fs-6 text-white" type="password" v-model="credentials_types.snmp_credentials.v3.auth_secret" style="cursor: text; width: 45%;" autocomplete="" placeholder="Auth. Password" >
                    <input v-if="mode=='edition'" class="btn border-bottom-kraken fw-light w-75 fs-6 text-white"  type="password" :value="'*****'" style="cursor: text; width: 50%;" autocomplete="">
                  </form>
              </div>
              <div class="input-group flex-nowrap mt-1">
                  <form class="w-100">
                    <button class="btn btn-kraken fs-6 w-25" tabindex="-1" style="cursor: default; pointer-events:none;" type="button" readonly>
                      <i class="fa-solid fa-lg fa-lock"></i>
                    </button>
                    <select v-if="mode=='add'" class="btn border-bottom-kraken fw-light fs-6 text-white" style="cursor: pointer; width: 30%;" title="Priv. Protocol" v-model="credentials_types.snmp_credentials.v3.priv_protocol">
                      <option :value="null">Priv. Protocol</option>
                      <option value="des">DES</option>
                      <option value="aes">AES</option>
                      <option value="aes256">AES-256</option>
                    </select>
                    <input v-if="mode=='add'" class="btn border-bottom-kraken fw-light fs-6 text-white" type="password" v-model="credentials_types.snmp_credentials.v3.priv_secret" style="cursor: text; width: 45%;" autocomplete="" placeholder="Priv. Password" >
                    <input v-if="mode=='edition'" class="btn border-bottom-kraken fw-light w-75 fs-6 text-white"  type="password" :value="'*****'" style="cursor: text; width: 50%;" autocomplete="">
                  </form>
              </div>
            </div>
            <div class="col-md-3"></div>
            <!-- Add button -->
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <div class="input-group flex-nowrap mt-1 mb-2">
                  <button v-if="mode=='add'" class="btn btn-kraken fs-6 w-100" :disabled="alteringCredential || addingCredential || deletingCredential " @click="addCredential">
                    <i class="fa-solid fa-lg fa-plus" :class="{'fa-spin': addingCredential}"></i>
                  </button>
              </div>
            </div>
          </div>
        </div>


      </div>





    </div>
<!-- END Container -->
  </div>
</template>

<script>
// Import the component with the line below.
//import Base from '@/components/Base.vue'

import axios from "axios";

export default {
  name: 'Credentials',
  components: {},
  data(){
    return {
      // General
      appclient: null,
      site: null,
      stage: null,
      mode: 'main',
      // Credentials
      credentials_types: {
        invalid: { name: 'Invalid', appname: null, action: null, data: {} },
        enables: { name: 'Enable', appname: null, action: null, data: {} },
        network_elements: { name: 'Network Elements', appname: null, action: null, data: {} },
        servers: { name: 'Servers', appname: null, action: null, data: {} },
        apis: { name:'API Credentials', appname: null, action: null, data: {} },
        tacacs_sk: { name: 'Tacacs Secret Key', appname: 'panoptico', action: 'reset', data: {} },
        cloud_credentials: { 
          name:'Cloud Credentials', 
          appname: null, 
          action: null, 
          data: {},
          // Cloud technologies.
          meraki: {
              key: null,
              key_confirm: null
            },
          aruba: {
            username: null,
            password: null,
            password_confirm: null,
            client_id: null,
            client_secret: null,
            customer_id: null
          } 
        },
        api_keys: { name:'API keys', appname: null, action: null, data: {} },
        aruba_creds: { 
          name:'ARUBA Credentials', 
          appname: null, 
          action: null, 
          data: {
            // Add
            client_id: null,
            client_secret: null,
            customer_id: null,
            // Edition

          } 
        },
        snmp_credentials:{
          name: "SNMP Credentials",
          appname: null, 
          action: null, 
          data: {},
          // Version 2 - Communities
          v2:{
            community: null
          },
          // Version 3 - Users
          v3:{
            username:       null,
            engineid:       null,
            auth_protocol:  null,
            auth_secret:    null,
            priv_protocol:  null,
            priv_secret:    null
          }
        }
      },
      triggers: {
        tacacs_sk: { app: 'panoptico' }
      },
      cloud_technology: 'meraki',
      userlessCredentials: ['enables','tacacs_sk','api_keys'],
      credentials: [],
      gettingCredentials: false,
      credentialsReady: false,
      credentialsMessage: "Waiting for selection.",
      selected_ctype: "invalid",
      timestamp: "...",
      // SNMP
      snmp_version: "v2",
      // Management
      selected_credential: {username: "Select a credential", password: "...", uid: null },
      currentAction: "",
      activeAction: false,
      // ---- Add
      addingCredential: false,
      newName: null,
      newAlias: null,
      newUsername: "",
      newPassword: "",
      newPasswordConfirm: "",
        // Aruba Specific
        search_by_aruba: 'username',

      // ---- Delete
      deletingCredential: false,
      // ---- Edition
      editingCredential: false,
      alteringCredential: false,
      editionNumber: "",
      editionName: null,
      editionAlias: null,
      editionUsername: "...",
      editionCurrentPassword: "",
      editionNewPassword: "",
      editionNewPasswordConfirm: "",
      // ------- Filtering
      search_by: "name",
      search_word: ""

    }
  },
  methods:{
    getCredentials(message="Getting credentials..."){
      this.credentials = []
      this.credentialsReady = false
      this.mode = 'main'
      this.search_by = 'name'
      this.search_word = ''
      if (this.selected_ctype == "invalid"){
        this.clear()
        this.credentialsMessage = "Waiting for selection."
        return
      }
      this.gettingCredentials = true
      this.credentialsMessage = message
      this.editingCredential = false
      this.clear()
      const params = {type: this.selected_ctype, withsecret: 'True'}
      const dest = this.site + '/suite/credentials/getCredentials'
      axios
          .get(dest, {params})
          .then(rx => {
              this.credentials = rx.data.credentials
              this.timestamp = rx.data.timestamp
              this.gettingCredentials = false
              this.credentialsReady = true
          })
          .catch(error => {
              this.credentialsMessage = this.processErrorMessage(error)
              this.selected_ctype = "invalid"
              this.timestamp = ""
              this.gettingCredentials = false
              this.credentialsReady = false
          });
      // DELETE
      this.triggerApp()
    },
    clear(){
      this.timestamp = ""
      this.newName = null
      this.newAlias = null
      this.newUsername = ""
      this.newPassword = ""
      this.newPasswordConfirm = ""
      this.editionNumber = null
      this.editionName = null
      this.editionAlias = null
      this.editionUsername = "..."
      this.editionCurrentPassword = ""
      this.editionNewPassword = ""
      this.editionNewPasswordConfirm = ""
      this.resetObject(this.credentials_types.cloud_credentials.meraki, null);
      this.resetObject(this.credentials_types.cloud_credentials.aruba, null);
      this.resetObject(this.credentials_types.snmp_credentials.v2, null);
      this.resetObject(this.credentials_types.snmp_credentials.v3, null);
    },
    reset(){
      this.credentialsReady = false
      this.selected_ctype = "invalid"
      this.credentialsMessage = "Waiting for selection."
      this.timestamp = ""
      this.newUsername = ""
      this.newPassword = ""
      this.newPasswordConfirm = ""
      this.editionNumber = null
      this.editionUsername = "..."
      this.editionCurrentPassword = ""
      this.editionNewPassword = ""
      this.editionNewPasswordConfirm = ""
    },
    manageCredential(_credential){
      this.selected_credential = _credential
    },
    addCredential(){
      // Protection
      if (this.newName == '' || this.newName == null){
        alert('Fill the name field.')
        return
      }
      if (this.newAlias == '' || this.newAlias == null){
        alert('Fill the alias field.')
        return
      }
      // Verification
      // For cloud
      var cdata = null
      if (this.selected_ctype == 'cloud_credentials'){
        // Meraki
        if (this.cloud_technology == 'meraki'){
          cdata = this.credentials_types.cloud_credentials.meraki
          // Key
          if (cdata.key == '' || cdata.key == null){
            alert('Fill the key field.')
            return
          }
          // Key Confirmation
          if (cdata.key_confirm == '' || cdata.key_confirm == null){
            alert('Confirm the key.')
            return
          }
          // Equality.
          if (cdata.key != cdata.key_confirm){
            alert("The key and the confirmation doesn't match.")
            return
          }
        }
        // Aruba
        else if (this.cloud_technology == 'aruba'){
          cdata = this.credentials_types.cloud_credentials.aruba
          // Username
          if (cdata.username == '' || cdata.username == null){
            alert('Fill the username field.')
            return
          }
          // Password
          if (cdata.password == '' || cdata.password == null){
            alert('Fill the password field.')
            return
          }
          // Password confirmation.
          if (cdata.password_confirm == '' || cdata.password_confirm == null){
            alert('Fill the password confirmation field.')
            return
          }
          // Password comparison.
          if (cdata.password != cdata.password_confirm){
            alert("The password and the confirmation doesn't match.")
            return
          }
          // Client ID.
          if (cdata.client_id == '' || cdata.client_id == null){
            alert('Fill the client ID field.')
            return
          }
          // Secret.
          if (cdata.client_secret == '' || cdata.client_secret== null){
            alert('Fill the client secret  field.')
            return
          }
          // Customer ID
          if (cdata.customer_id == '' || cdata.customer_id == null){
            alert('Fill the customer ID field.')
            return
          }
        }
        cdata.technology = this.cloud_technology
      }
      // For SNMP
      else if (this.selected_ctype == 'snmp_credentials'){
        if (this.snmp_version == 'v2'){
          cdata = this.credentials_types.snmp_credentials.v2
          if (!cdata.community){
            alert('Empty community value.')
            return
          }
        }
        else if (this.snmp_version == 'v3'){
          cdata = this.credentials_types.snmp_credentials.v3
          if (!cdata.username){
            alert('Empty username value.')
            return
          }
          if (!cdata.auth_protocol){
            alert('Invalid Auth. protocol value.')
            return
          }
          if (!cdata.auth_secret){
            alert('Empty Auth. Password value.')
            return
          }
          // Priv Validation
          if (cdata.priv_protocol && !cdata.priv_secret){
            alert('Invalid Priv. Password value.')
            return
          }
        }
        cdata.version = this.snmp_version
      }
      // For everything except cloud.
      else{
        if (this.newPassword == ''){
          alert('Fill the password field.')
          return
        }
        if (this.userlessCredentials.indexOf(this.selected_ctype) === -1){
          if (this.newUsername == ''){
            alert('Fill the username field.')
            return
          }
        }
        if (this.newPassword != this.newPasswordConfirm){
          alert("The new password and the confirmation doesn't match.")
          return
        }
      }
      this.addingCredential = true
      const params = {
        name: this.newName,
        alias: this.newAlias,
        username: this.newUsername, 
        secret: this.newPassword, 
        type: this.selected_ctype,
        special: this.credentials_types[this.selected_ctype].data,
        specific: cdata
      }
      const dest = this.site + '/suite/credentials/addCredential'
      axios
          .post(dest, {params})
          .then(rx => {
            this.getCredentials("Updating credentials, new credential detected.")
            this.addingCredential = false
            // Execute trigger.
            this.triggerApp()
          })
          .catch(error => {
            this.credentialsMessage = this.processErrorMessage(error)
            this.addingCredential = false

          });
    },
    deleteCredential(_credential, _number){
      var confirmation = confirm(`Are you sure you want to delete the credential "# ${_number}" of "${this.capitalize(this.selected_ctype.replace('_',' '))}" type?`)
      if (!confirmation){
        return 
      }
      this.deletingCredential = true
      this.activeAction = true
      //const params = { credential: _credential.uid, type: this.selected_ctype, specific: _credential}
      const params = { credential: _credential, type: this.selected_ctype }
      const dest = this.site + '/suite/credentials/deleteCredential'
      axios
          .post(dest, {params})
          .then(rx => {
            this.getCredentials("Updating credentials, a credential has been deleted.")
            this.deletingCredential = false
            this.activeAction = false
            // Execute trigger.
            this.triggerApp()
          })
          .catch(error => {
            this.credentialsMessage = this.processErrorMessage(error)
            this.deletingCredential = false
            this.activeAction = false
          });
    },
    editCredential(){
      // Protection
      if (this.editionName== '' || this.editionName == null){
        alert('Fill the credential name field.')
        return
      }
      if (this.editionAlias== '' || this.editionAlias == null){
        alert('Fill the credential alias field.')
        return
      }
      
      //if (this.editionNewPassword == ''){
      //  alert('Fill the password field.')
      //  return
      //}
      if (this.editionNewPassword != this.editionNewPasswordConfirm){
        alert("The new password and the confirmation doesn't match.")
        return
      }
      this.alteringCredential = true
      this.activeAction = true
      const params = { 
        name: this.editionName, 
        alias: this.editionAlias,
        credential: this.selected_credential.uid, 
        newSecret: this.editionNewPassword, 
        type: this.selected_ctype
      }
      const dest = this.site + '/suite/credentials/editCredential'
      axios
          .post(dest, {params})
          .then(rx => {
            this.getCredentials("Updating credentials, the password has been successfully changed...")
            this.alteringCredential = false
            this.activeAction = false
            // Execute trigger.
            this.triggerApp()
          })
          .catch(error => {
            this.credentialsMessage = this.processErrorMessage(error)
            this.alteringCredential = false
            this.activeAction = false
          });


     
    },
    setEdition(_selected_credential, _number){
      this.mode = 'edition'
      this.editingCredential = true
      this.selected_credential = _selected_credential
      this.editionName = this.selected_credential.name
      this.editionAlias = this.selected_credential.alias
      
      this.editionUsername = this.selected_credential.username
      this.editionCurrentPassword = this.selected_credential.password.substring(0,3) + "*****"
      this.editionNumber = _number
    },
    setCloudEdition(_selected_credential){
      this.mode = 'edition'
      this.editingCredential = true
      this.selected_credential = this.cloneObject(_selected_credential)
      this.cloud_technology = this.selected_credential.cloud_technology
      this.newName = this.selected_credential.name
      this.newAlias = this.selected_credential.alias
      this.credentials_types.cloud_credentials[this.cloud_technology] = this.selected_credential.data
    },
    // Trigger
    triggerApp(){
      var cs = this.credentials_types[this.selected_ctype]
      var action = cs.action
      var appname = cs.appname
      if(appname == null && action == null){
        return
      }
      // Send the request.
      const params = { appname: appname, action: action }
      const dest = this.site + `/suite/credentials/triggerApp`
      axios
          .post(dest, params )
          .then(rx => {
              // OK
              console.log('Trigger sended to:', appname)
          })
          .catch(error => {
              this.processErrorMessage(error, 'console')
      });
    },
    // Errors
    processErrorMessage(error, mode="alert"){
        var err_message = null
        try {
            err_message = error.response.data.data.errorMessage
        } 
        catch (nerror) {
            try { 
                err_message = error.response.data.errorMessage
            } 
            catch (error) { 
                console.log(error) 
            }
        }
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
    return err_message
    },
    // Miscelaneous
    resetObject(ob, val){
      Object.keys(ob).forEach(k => ob[k] = val);
    },
    capitalize(_string){
        if (_string == null){return ""}
        const lower = String(_string).toLowerCase()
        return String(_string).charAt(0).toUpperCase() + lower.slice(1)
    },
    cloneObject(_object){
      return JSON.parse(JSON.stringify(_object))
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  computed: {
    filteredCreds(){
        if (this.search_word == ''){
            return this.credentials
        }
        this.search_word = this.search_word.toLowerCase()
        return this.credentials.filter( cred => String(cred[this.search_by]).toLowerCase().includes( this.search_word ) );
    }
  },
  created: function(){
    //this.appclient = localStorage.getItem('vrfaware_client')
    //this.appServiceUrl = this.appServiceUrl.replace('_CLIENT_NAME_', this.appclient)
    this.stage = process.env.NODE_ENV
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
  }
}
</script>

<style scoped>

  .border-suite{
    border-top: solid 2px rgb(0, 48, 90);
    border-bottom: solid 2px rgb(0, 48, 90);
    border-left: solid 2px rgb(0, 48, 90);
    border-right: solid 2px rgb(0, 48, 90);
  }
  .border-suite-bottom{
    border-bottom: solid 2px rgb(0, 48, 90);
  }

  .bg-suite{
    color: White;
    background-color: rgb(0, 48, 90);
    text-shadow: 3px 5px 4px Black;
  }

  .btn-kraken{
    color: White;
    background-color: rgb(0, 48, 90);
    transition-duration: 0.5s;
    text-shadow: 3px 5px 4px Black;
    border-left: solid 6px transparent;
    border-right: solid 6px transparent;
  }
  .btn-kraken:hover{
    color: rgb(0, 179, 255);
    background-color: rgb(1, 77, 144);
  }

  .btn-kraken-danger{
    color: White;
    background-color: rgb(140, 0, 0);
    transition-duration: 0.5s;
    text-shadow: 3px 5px 4px Black;
    border-left: solid 6px transparent;
    border-right: solid 6px transparent;
  }
  .btn-suite-danger{
    color: rgb(255, 255, 255);
    background-color: rgb(208, 0, 0);
  }
  .btn-suite-danger:hover{
    color: rgb(133, 133, 133);
    background-color: rgb(169, 1, 1);
  }

  .selected-type{
    border-left: solid 6px rgb(0, 179, 255);
    color: rgb(0, 179, 255);
  }

  .selected-row{
    transition-duration: 0.5s;
  }
  .selected-row:hover{
    opacity: 0.7;
  }

  .disabled-div{
    pointer-events: none;
    opacity: 0.5;
  }

  .menu-option{
        color: rgb(255, 255, 255);
        border: solid 2px Black;
        transition-duration: 0.4s;
  }
  .menu-option:hover{
      color: rgb(72,167,238);
      border-bottom: solid 2px rgb(162, 200, 250);
  }

  .bg-input{
      background-color: rgb(7,13,15);
      color: white;
  }
  .temporal-disable{
      opacity: 0.5;
      pointer-events: none;
  }
  .btn-kraken{
      background-color: rgb(20, 63, 162);
      color: white;
      transition-duration: 0.5s;
      text-shadow: 3px 5px 4px Black;
      border-left: solid 3px transparent;
      border-right: solid 3px transparent;
  }
  .btn-kraken:hover{
      background-color: rgb(0, 17, 39);
      color: rgb(0, 211, 249);
  }
  .bg-kraken{
      background-color: rgb(20, 63, 162);
      color: white;
      transition-duration: 0.5s;
      text-shadow: 3px 5px 4px Black;
      border-left: solid 3px transparent;
      border-right: solid 3px transparent;
  }
  .border-bottom-kraken{
    border-bottom: solid 1px rgb(20, 63, 162);
  }
  .border-top-kraken{
    border-top: solid 1px rgb(20, 63, 162);
  }


  /* Table with static header */
    .tableFixHead {
        overflow-y: auto;
      }
    .tableFixHead thead th {
        position: sticky;
        top: 0;
        text-align: center;
        z-index: 1;
    }
    table {
        border-collapse: collapse;
        width: 100%;
    }
    th, td {
        padding: 8px 16px;
    }
    th {
        background: #eee;
    }

</style>
